import view from '@/api/report/form-view-model'

export const actions = {
  fetchFormView(context, attributes = {}) {
    return view.get({ params: attributes })
  },
}